import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
import { Subject, BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SurveyProductService {

  private datosPreguntasV3: Subject<any> = new Subject<any>();
  recibidosPreguntasV3 = this.datosPreguntasV3.asObservable();

  private datosSurvProd: Subject<any> = new Subject<any>();
  recibidosSurvProd = this.datosSurvProd.asObservable();

  private eliminarInfo = new BehaviorSubject('');
  mensajeActual = this.eliminarInfo.asObservable();

  constructor(private http:HttpClient) { }

  enviaDatosASurvProd(datos:any){
    this.datosPreguntasV3.next(datos);
  }

  eliminarInfoSurveyProduct(mensaje: string) {
    this.eliminarInfo.next(mensaje);
  }

  enviaDatosAPreguntasV3(datos:any){
    this.datosSurvProd.next(datos);
  }

  getProdCertAct(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + localStorage.getItem('companyID'));
  }

  getIdiomasProd(fecha: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + localStorage.getItem('companyID'), fecha);
  }

  getCatRespuestasReactivos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.respuestasReactivos);
  }
  getCatDatosForAll(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.datosForAll + localStorage.getItem('instituto_id'));
  }
  getCatDemograficos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.demograficos);
  }

  getCatalogo(instituto:string, tipoSeccion:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getCatalogo + instituto + '/' + tipoSeccion);
  }

  getCatalogov2(instituto:string, tipoSeccion:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getCatalogov2 + instituto + '/' + tipoSeccion);
  }

  getSeccionesCuestionario(surveyProductId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getSeccionesCuestionario + surveyProductId);
  }

  getCatIdiomasSurvey(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.idiomas);
  }
  setSeccionesCuestionario(surveyProductId:any, secciones:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.setSeccionesCuestionario + surveyProductId, secciones);
  }
  getTemplate(templateId:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getTemplate + templateId);
  }
  getPreguntaCatMaster(idPregunta:number){
    return this.http.get<any>(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getPreguntaCatMaster + idPregunta);
  }

  getFormVoices(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getFormVoices + localStorage.getItem('productoID'));
  }
}
